import { AbstractControl, ValidationErrors } from '@angular/forms'

export function ConditionalRequiredValidator(
    controllingField: string,
    expectedValue: any,
    dependentField: string,
    valuesMustMatch: boolean,
    errorKey: string = 'required'
) {
    return (group: AbstractControl): ValidationErrors | null => {
        const controlValue = group.get(controllingField)?.value
        const dependentControl = group.get(dependentField)

        if (!dependentControl) return null

        if (
            (valuesMustMatch ? controlValue === expectedValue : controlValue !== expectedValue) &&
            !dependentControl.value
        ) {
            dependentControl.setErrors({ [errorKey]: true })
        } else {
            if (dependentControl.hasError(errorKey)) {
                const errors = { ...dependentControl.errors }
                delete errors[errorKey]
                dependentControl.setErrors(Object.keys(errors).length ? errors : null)
            }
        }

        return null
    }
}
